import React from 'react';
import FileUploader from '../../../file_uploader/FileUploader';

import { ArrowIcon } from '../../../utils/icons';


// import { StyledEngineProvider } from '@mui/material/styles';
// import dayjs from 'dayjs';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// import { DatePicker } from './DatePicker';
// import { CheckboxGroup, Checkbox } from 'react-aria-components';




function ModalField({ field, value, onChange, error }) {
  const handleChange = (e) => {
    const { name, type, checked, files } = e.target;
    const targetValue = e.target.value;
    
    if (field.type === 'switch') {
      // Handle switch as boolean toggle
      onChange(name, checked);
    } else if (type === 'checkbox' && (field.type === 'checkbox' || field.type === 'checkbox_list')) {
      // Handle multiple checkboxes (including checkbox_list groups)
      const currentValues = Array.isArray(value) ? value : [];
      const newValues = checked ? [...currentValues, targetValue] : currentValues.filter(v => v !== targetValue);
      onChange(name, newValues);
    } else if (type === 'file') {
      onChange(name, type === 'file' ? (files?.[0] ?? null) : value);
    } else {
      onChange(name, targetValue);
    }
  };

  // const Label = () => {
  //   return (
  //     <label className="form-label" htmlFor={field.name}>
  //       {field.label}
  //       {field.required && <span className='required-asterisk form-required'> *</span>}
  //     </label>
  //   );
  // } 

  const FormError = ({ error }) => {
    return (
      <div className='form-error'>{error}</div>
    );
  }

  const renderField = () => {
    switch (field.type) {

      // case 'checkbox_group':
      //   return (
      //     <div className={`form-group form__input-wrapper checkbox-wrapper wrapper-${field.name}`}>
      //       <CheckboxGroup label={field.label} className='checkbox-group'>
      //         {field.required && <span className='form-required'> *</span>}
      //         {field.options.map((option, index) => (
      //           <Checkbox key={index} value={option.value} className='checkbox-option checkbox-list'>{option.label}</Checkbox>
      //         ))}
      //       </CheckboxGroup>
      //       {error && <FormError error={error} />}
      //     </div>
      //   );

      case 'radio_list':
      case 'checkbox_list':
        return (
          <div className={`form-group form__input-wrapper checkbox-wrapper wrapper-${field.name}`}>
            <label className='form-label'>
              {field.label}
              {field.required && <span className='form-required'> *</span>}
            </label>
            {field.options.map((option, index) => (
              <div key={index} className='checkbox-option checkbox-list' >
                <label htmlFor={field.name + index} className='form-label-inner'>
                  <input
                    type={field.type === 'checkbox_list' ? 'checkbox' : 'radio'}
                    name={field.name}
                    id={field.name + index}
                    value={option.value}
                    checked={
                      field.checked ||
                      (field.type === 'checkbox_list'
                        ? Array.isArray(value) && value.includes(option.value)
                        : value === option.value)
                    }
                    onChange={handleChange}
                  />
                  <span className='form-value-label'>{option.label ?? option.value}</span>
                </label>
              </div>
            ))}
            {error && <FormError error={error} />}
          </div>
        );

      case 'checkbox':
        return (
          <div className={`form-group form__input-wrapper checkbox-wrapper wrapper-${field.name}`}>
            {/* <label className='form-label'>
              {field.label}
              {field.required && <span className='form-required'> *</span>}
            </label> */}
            {field.options.map((option, index) => (
              <div key={index} className='checkbox-option checkbox-single' >
                <label htmlFor={field.name + index} className='form-label-inner'>
                  <input
                    type={field.type}
                    name={field.name}
                    id={field.name + index}
                    value={option.value}
                    checked={field.checked || (field.type === 'checkbox' ? Array.isArray(value) && value.includes(option.value) : value === option.value)}
                    onChange={handleChange}
                  />
                  <span className={`form-value-label ${field.fontWeight == 'bold' ? `strong` : ''}`}>{field.label} {field.required && <span className='form-required'> *</span>}</span>
                </label>
              </div>
            ))}
            {error && <FormError error={error} />}
          </div>
        );

      case 'radio':
          return (
            <div className={`form-group form__input-wrapper checkbox-wrapper radio-wrapper wrapper-${field.name}`}>
              <label className='form-label'>
                {field.label}
                {field.required && <span className='form-required'> *</span>}
              </label>
              {field.options.map((option, index) => (
                <div key={index} className='radio-single' >
                  <label htmlFor={field.name + index} className='form-label-inner'>
                    <input
                      type={field.type}
                      name={field.name}
                      id={field.name + index}
                      value={option.value}
                      checked={field.checked || value === option.value}
                      onChange={handleChange}
                    />
                    <span className='form-value-label'>{option.label ?? option.value}</span>
                    {/* <label className='form-value-label' htmlFor={field.name + index}>{option.label ?? option.value}</label> */}
                  </label>
                </div>
              ))}
              {error && <FormError error={error} />}
            </div>
          );
      

      case 'switch':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>  
            <div className={`checkbox-wrapper ${field.size ? field.size : ''}`} >
              <label htmlFor={field.name} className='form-label-inner' >
                <input
                  className={`switch-checkbox`}
                  type='checkbox'
                  name={field.name}
                  id={field.name}
                  checked={value === true || value === 'true'}
                  onChange={handleChange}
                />
              </label>

              <label className="form-label" htmlFor={field.name}>
                {field.label}
                {field.required && <span className='required-asterisk form-required'> *</span>}
              </label>
            </div>
            
            {error && <FormError error={error} />}
          </div>
        );

      case 'text':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            {/* {field.label && (
              <Label />
            )} */}
            <label className='form-label' htmlFor={field.name}>
              <span className='form-label-span'>{field.label} {field.required && <span className='form-required'> *</span>}</span>
              
              <input
                type="text"
                name={field.name}
                value={value || ''}
                onChange={handleChange}
                placeholder={field.placeholder}
                className='form-text form-control'
              />
            </label>
            {error && <FormError error={error} />}
          </div>
        );

      case 'hidden':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            {/* {field.label && (
              <Label />
            )} */}
            <label className='form-label' htmlFor={field.name}>
              <span className='form-label-span'>{field.label} {field.required && <span className='form-required'> *</span>}</span>
              
            <input
              type="hidden"
              name={field.name}
              value={value || ''}
              onChange={handleChange}
              placeholder={field.placeholder}
              className='form-text form-control'
            />
            </label>
            {error && <FormError error={error} />}
          </div>
        );

      case 'date':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            <label className='form-label' htmlFor={field.name}>
              <span className='form-label-span'>{field.label} {field.required && <span className='form-required'> *</span>}</span>
              <input
                  type="date"
                  name={field.name}
                  value={value || ''}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                  className='form-text form-control'
                />
                
              {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={field.placeholder}
                  value={value ? dayjs(value) : null}
                  onChange={(d) => onChange(field.name, d ? dayjs(d).format('YYYY-MM-DD') : '')}
                  slotProps={{ textField: { size: 'small', error: !!error, helperText: error } }}
                />
              </LocalizationProvider> */}
            </label>
            {error && <FormError error={error} />}
          </div>
        );

      


      case 'textarea':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            {/* {field.label && (
              <Label />
            )} */}
            <label className='form-label' htmlFor={field.name}>
              <span className='form-label-span' >{field.label} {field.required && <span className='form-required'> *</span>}</span>
              
            <textarea
              name={field.name}
              value={value || ''}
              onChange={handleChange}
              placeholder={field.placeholder}
              className='form-textarea form-control'
              
            />
            </label>
            {error && <FormError error={error} />}
          </div>
        );

      case 'select':
        // Use a default option value if provided, but keep it disabled so it
        // acts as a non-selectable placeholder once the user changes it.
        const defaultOption = Array.isArray(field.options)
          ? field.options.find((o) => o.defaultValue)
          : null;
        const selectValue = value ?? (defaultOption ? defaultOption.value : '');

        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            {/* {field.label && (
              <Label />
            )} */}
            <label className='form-label' htmlFor={field.name}>
              <span className='form-label-span' >{field.label} {field.required && <span className='form-required'>*</span>}</span>
              

              <div className="select-wrapper select-wrapper--primary">
                <ArrowIcon />

                <select
                  name={field.name}
                  id={field.name}
                  value={selectValue}
                  onChange={handleChange}
                  className="form-control"
                >
                  {field.placeholder && (
                    <option value="" disabled>
                      {field.placeholder}
                    </option>
                  )}
                  {field.options.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                      disabled={option.disabled || option.defaultValue}
                    >
                      {option.value}
                    </option>
                  ))}
                </select>
              </div>
            </label>
            {error && <FormError error={error} />}
          </div>
        );

      case 'readOnly':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            <label className='form-label' htmlFor={field.name}>
              <span className='form-label-span' >{field.label}</span>
            

              <textarea
                name={field.name}
                className={`form-control form-control--read-only`}
                type="textarea"
                readOnly
                value={field.value}
              />
            </label>
          </div>
        );


      case 'file':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            <label className='form-label' htmlFor={field.name}>
              {field.label}
              {field.required && <span className='form-required'> *</span>}
            </label>
            <FileUploader
              accept={field.accept || '*/*'}
              maxSizeMB={field.maxSizeMB ?? 10}
              onFileSelect={(file) => onChange(field.name, file ?? null)}
            />
            {error && <FormError error={error} />}
          </div>
        );

      case 'downloadLink':
        return (
          <div className={`form-group form__input-wrapper wrapper-${field.name}`}>
            <label className='form-label' htmlFor={field.name}>
              {field.label}
            </label>
            <a className='button button--secondary button--bordered download-link' href={field.value} target='_blank' rel='noopener noreferrer'>
              {field.linkLabel}
            </a>
          </div>
        );

      default:
        return null;
    }
  };

  return renderField();
}

export default React.memo(ModalField);
